import React, { useEffect, useState } from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import { Link } from "react-router-dom";
import brandImg from "../../Assets/images/pro-img-2.png";
import { useParams } from "react-router-dom";
import {
  CurrencyConvert,
  CurrencyConvertHistory,
  decodeID,
  getDate,
  getPriceHelper,
} from "../../utils/Helper";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "../layout/FrontLoader";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { Modal } from "react-bootstrap";
import Shippingdetails from "../../Modal/Shippingdetails";
import OrderCancelMessage from "../../Modal/OrderCancelMessage";
import OrderCancel from "../../Modal/OrderCancel";
import OrderSurveyMessage from "../../Modal/OrderSurveyMessage";
import SurveyModal from "../../Modal/SurveyModal";

function OrderDetail() {
  const { id } = useParams();
  const orderView = useMakeRequest();
  const [currency, setCurrency] = useState("USD");
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [messageshow, setMessageShow] = useState(false);
  const [cancelShow, setCancelShow] = useState(false);
  const [surveymessageShow, setSurveymessageShow] = useState(false)
  const [surveyShow , setSurveyShow]  = useState(false)
  const [apiRefresh , setApiRefresh] = useState(false)

  useEffect(() => {
    const payload = {
      order_id: decodeID(id),
    };
    orderView.makeRequest({
      payload,
      url: ApiConstants?.OrderDetail,
      toastStatus: false,
    });
  }, [apiRefresh]);

  const getTaxValue = (e: any) => {
    if (e?.tax_amount && e?.total_amount) {
      const total =
        Number(e?.total_shipping_price) +
        Number(e?.total_product_price) +
        Number(e?.other_charges);
      const taxValue = (total * e?.tax_amount) / 100;
      return `${taxValue.toFixed(2)}`;
    } else {
      return "$ 0.00";
    }
  };

  const GrandTotal = (e: any) => {
    if (e) {
      const shippingPrice = e?.quantity * e?.per_product_price;
      const total = Number(shippingPrice)
      return total?.toFixed(2)
    }
  }

  useEffect(()=>{
   if(orderView?.status){
    if(orderView?.data?.data.is_survey == 0 && orderView?.data?.data?.status == 2){
      setSurveymessageShow(true)
    }else{
      setSurveymessageShow(false)
    }
   }
  },[orderView?.status])


  return (
    <>
      {orderView?.loading ? <FrontLoader /> : null}
      <main>
        <section
          className="main-banner small-banner"
          style={{ background: `url(${profileBanner}) center/cover` }}
        >
          <div className="container">
            <h1 className="small-banner-heading">
              {LanguageConstants?.MYORDER}
            </h1>
            <nav className="com-breadcrumb" aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/profile">{LanguageConstants?.PROFILE}</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/order">{LanguageConstants?.MYORDER}</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {LanguageConstants?.VIEW}
                </li>
              </ol>
            </nav>
          </div>
        </section>
        {/* top banner section end  */}

        <div className="">
          <div className="container">
            <div className="quote-ttl-price">
              {/* <div className="quote-ttl-price-left">
                      <div className="quote-ttl me-3 me-sm-5">Part Name (KJDD5)</div>
                      <div className="quote-price ms-0">$50.00</div>
                  </div> */}
              {(orderView?.data?.data?.status == "0") ? (
                <span className="quote-bnr-tag ms-auto">
                  <td className="yellow-text">{LanguageConstants?.PENDING}</td>
                </span>
              ) : orderView?.data?.data?.status == "1" ? (
                <span className="quote-bnr-tag ms-auto">
                  <td className="blue-text">
                    {LanguageConstants?.INTRANSIT}
                  </td>
                </span>
              ) :
                orderView?.data?.data?.status == "4" ? (
                  <span className="quote-bnr-tag ms-auto">
                    <td className="yellow-text">
                      {LanguageConstants?.Progress}
                    </td>
                  </span>
                ) : orderView?.data?.data?.status == "2" ? (
                  <span className="quote-bnr-tag ms-auto">
                    <td className="approved-text">{LanguageConstants?.DELIVERD}</td>
                  </span>
                ) : (
                  <span className="quote-bnr-tag ms-auto">
                    {" "}
                    <td className="red-text">{LanguageConstants?.CANVELLED}</td>
                  </span>
                )}
            {/* {orderView?.data?.data?.shipping_company ? (
                  <span className="quote-bnr-tag">
              <div className="preview-txt-new cursor-pointer" onClick={() => setShow(true)} >
                <i className="icon-eye-open"></i> {LanguageConstants?.TRACKING}</div>
                </span>
              ):null} */}
            </div>
            <div className="quote-card-box">
              <div className="quote-head">
                <div>
                  <label className="quote-label">
                    {LanguageConstants?.ORDERID}
                  </label>
                  <div className="quote-label-ct">
                    {orderView?.data?.data?.uuid}
                  </div>
                </div>
                <div>
                  <label className="quote-label">
                    {LanguageConstants?.QUOTATIONID}
                  </label>
                  <div className="quote-label-ct">
                    {orderView?.data?.data?.quotation_id}
                  </div>
                </div>
                <div>
                  <label className="quote-label">
                    {LanguageConstants?.DATE}
                  </label>
                  <div className="quote-label-ct">
                    {getDate(orderView?.data?.data?.created_at)}
                  </div>
                </div>
                <div>
                  <label className="quote-label">
                    {LanguageConstants?.ORRDERDELIVERYADDRESS}
                  </label>
                  {/* <div className="quote-label-ct">{`${orderView?.data?.data?.street_line} , ${orderView?.data?.data?.loaction_type == "1" ? 'Residential' : 'Instructions'}`}</div> */}
                  <div className="quote-label-ct">{`${orderView?.data?.data?.street_line}`}</div>
                </div>
              </div>
              <div className="card-box mb-5 mt-3">
                <div className="table-responsive com-table rqst-table rqst-table-view">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="text-center">{LanguageConstants?.Item}</th>
                        <th className="text-center">{LanguageConstants?.ORDER_QTY}</th>
                        <th className="text-center">{LanguageConstants?.BRAND}</th>
                        <th className="text-center">{LanguageConstants?.PARTNAME}</th>
                        {/* <th className="text-center">{LanguageConstants?.QUANTITY}</th> */}
                        <th className="text-center">{LanguageConstants?.Description}</th>
                        {/* <th className="text-center">{LanguageConstants?.SERIALNUMBER}</th> */}
                        {/* <th className="text-center">{LanguageConstants?.MODELNUMBER}</th> */}
                        {/* <th className="text-center">ETA</th> */}
                        <th className="text-center">{LanguageConstants?.PRE_PRODUCT_PRICE}</th>
                        <th className="text-center">{LanguageConstants?.EXTED_PRICE}</th>
                        {/* <th className="text-center">{LanguageConstants?.PHOTOS_VIDEO}</th> */}
                        <th className="text-center">ETA</th>
                      </tr>
                    </thead>

                    <tbody>
                      {orderView?.data?.data?.quotation_detail?.quotes_detail?.map((res: any, i: any) => (

                        <tr>
                          <td className="text-center">{i + 1}<br /> </td>
                          <td className="text-center">{res?.quantity} <br /> </td>
                          {res?.is_other_brand == "1" ?
                            <td className="text-center"> {res?.other_brand_name}</td>
                            :
                            <td className="text-center">{res?.brand_detail?.name}</td>
                          }
                          <td className="text-center">{res?.part_number}</td>
                          {res?.description ? <td className="text-center">{res?.description}</td> : <td className="text-center">N/A</td>}
                          {/* {res?.serial_number ? <td className="text-center">{res?.serial_number}</td> : <td className="text-center">N/A</td>} */}
                          {/* {res?.model_number ? <td className="text-center">{res?.model_number}</td> : <td className="text-center">N/A</td>} */}
                          <td className="text-center">${res?.per_product_price ? getPriceHelper(CurrencyConvertHistory(res?.per_product_price, currency)) : '0.00'}</td>
                          {/* {res?.eta_day ? <td className="text-center">{res?.eta_day}</td> : <td className="text-center">N/A</td>} */}
                          <td className="text-center">${res?.eta_day ? getPriceHelper(CurrencyConvertHistory(GrandTotal(res), currency)) : '0.00'} </td>
                          <td className="text-center">{res?.eta_day ? res?.eta_day : 'N/A'}</td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card-box mb-5 mt-3">
                <div className="row">
                  <div className="col-md-6 quote-mid-col py-0 border-0">
                    <div className="provide-quotation-wrap">
                      <div className="quote-mid">
                        <h3 className="quote-ttl">
                          {LanguageConstants?.PRICE_BRACKDOWN}
                        </h3>
                        <div className="table-responsive ">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td>{LanguageConstants?.TOTALPRODUCTAMOUNT}</td>
                                <th>
                                  {getPriceHelper(
                                    CurrencyConvert(
                                      orderView?.data?.data?.quotation_detail
                                        ?.total_product_price,
                                      currency
                                    )
                                  )}
                                </th>
                              </tr>
                              <tr>
                                <td>{LanguageConstants?.TOTALSHIIPNGAMOUNT}</td>
                                <th>
                                  {getPriceHelper(
                                    CurrencyConvert(
                                      orderView?.data?.data?.quotation_detail
                                        ?.total_shipping_price,
                                      currency
                                    )
                                  )}
                                </th>
                              </tr>
                              <tr>
                                <td>
                                  {LanguageConstants?.OTHER}{" "}
                                  {LanguageConstants?.CHARGES}
                                </td>
                                <th>
                                  {orderView?.data?.data?.quotation_detail
                                    ?.other_charges
                                    ? getPriceHelper(
                                      CurrencyConvert(
                                        orderView?.data?.data
                                          ?.quotation_detail?.other_charges,
                                        currency
                                      )
                                    )
                                    : "$0.00"}
                                </th>
                              </tr>
                              <tr>
                                <td>{LanguageConstants?.TOTALTAX}</td>
                                <th>
                                  {orderView?.data?.data?.quotation_detail
                                    ?.tax_amount
                                    ? getPriceHelper(
                                      CurrencyConvert(
                                        getTaxValue(
                                          orderView?.data?.data
                                            ?.quotation_detail
                                        ),
                                        currency
                                      )
                                    )
                                    : "$0.00"}
                                </th>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td className="fw-bold">
                                  {LanguageConstants?.GRANDTOTAL}
                                </td>
                                <td className="text-end fw-bold">
                                  {getPriceHelper(
                                    CurrencyConvert(
                                      orderView?.data?.data?.quotation_detail
                                        ?.total_amount,
                                      currency
                                    )
                                  )}
                                </td>
                              </tr>
                                <p style={{color:'red'}}>{LanguageConstants?.PRIZEMESSAGE}</p>
                            </tfoot>
                          </table>
                        </div>
                      </div>

                      <div className="quote-foot-btns">
                          {(orderView?.data?.data?.is_over_all_survey == 0 && orderView?.data?.data?.is_survey == 1) && orderView?.data?.data?.status == 2 ? (
                          <button
                            className="reject-approve-btn blue-btn"
                            onClick={() => setSurveyShow(true)}
                          >
                            {LanguageConstants?.GIVE_SURVEY}
                          </button>
                        ) : null} 
                        {orderView?.data?.data?.is_cancel == "0" &&
                          (orderView?.data?.data?.status == "0" ||
                            orderView?.data?.data?.status == "1") ? (
                          <button
                            className="reject-approve-btn reject"
                            onClick={() => setMessageShow(true)}
                          >
                            {LanguageConstants?.CANCEL}
                          </button>
                        ) : null}
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* show shpinng details start */}
      <Modal show={show}>
        <Shippingdetails setShow={setShow} data={orderView?.data?.data} />
      </Modal>
      {/* show shpinng details end */}

      {/* cancel message show start */}
      <Modal show={messageshow}>
        <OrderCancelMessage
          setMessageShow={setMessageShow}
          setCancelShow={setCancelShow}
          data={orderView?.data?.data}
        />
      </Modal>
      {/* cancel message show end */}

      {/* cancel  show start */}
      <Modal show={cancelShow}>
        <OrderCancel
          setCancelShow={setCancelShow}
          data={orderView?.data?.data}
        />
      </Modal>
      {/* cancel  show end */}

      {/* Survey message Modal show  start*/}
      <Modal show={surveymessageShow}>
        <OrderSurveyMessage
          data={orderView?.data?.data}
          setSurveymessageShow={setSurveymessageShow}
          surveymessageShow={surveymessageShow}
          setSurveyShow={setSurveyShow}
          setApiRefresh={setApiRefresh}
          />
      </Modal>
      {/* Survey message Modal show  end*/}

      {/* Survey Modal show  start*/}
      <Modal show={surveyShow}>
      <SurveyModal
          data={orderView?.data?.data}
          setSurveyShow={setSurveyShow}
          setApiRefresh={setApiRefresh}
      />
      </Modal>
      {/* Survey  Modal show  end*/}


    </>
  );
}

export default OrderDetail;